var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarIconsMatrix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "matrix__Property 1=Matrix, State=Default",
    className: "matrix__Property matrix__1=Matrix, matrix__State=Default"
  }, /*#__PURE__*/React.createElement("path", {
    id: "matrix__Vector 2137 (Stroke)",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.793 3.58c0-.967.783-1.75 1.75-1.75h16.903a1.75 1.75 0 0 1 1.75 1.765l-.156 16.842a1.75 1.75 0 0 1-1.75 1.734H3.543a1.75 1.75 0 0 1-1.75-1.75V3.579Zm1.75-.25a.25.25 0 0 0-.25.25v7.67h7.916l.037-7.92H3.543Zm9.203 0-.037 7.92h7.916l.07-7.669a.25.25 0 0 0-.25-.252h-7.7Zm7.865 9.42h-7.909l-.037 7.92h7.625a.25.25 0 0 0 .25-.247l.071-7.673Zm-9.446 7.92.037-7.92H3.293v7.67c0 .139.112.25.25.25h7.622Z",
    className: "matrix__Vector matrix__2137 matrix__(Stroke)",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIconsMatrix);
export default __webpack_public_path__ + "static/media/sidebar-icons-matrix.968e69a8e0836be2bba3247407a218a4.svg";
export { ForwardRef as ReactComponent };